"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkActionsFilter = void 0;
const react_1 = require("react");
const utils_1 = require("../../../client/proposal/hooks/utils");
/**
 * Converts pieces of store/state/whatever to optimized API-compatible filter that can be used for bulk edit or reclassification.
 */
const useBulkActionsFilter = ({ selectAllMode, tableSearch, excludedItemsIds, tableFilter, selectedAttributeNode, productTreeNode, hasLockedProducts, includeAttributeStatuses, reviewStatus, }) => {
    const filterValue = (0, react_1.useMemo)(() => (0, utils_1.getOptimizedPresentationAwareFilter)({
        productTreeNode,
        attributeNode: selectedAttributeNode,
        selectAllMode,
        selectedProductIds: excludedItemsIds,
        search: tableSearch,
        tableFilter,
        hasLockedProducts,
        includeAttributeStatuses,
        reviewStatus,
    }), [
        productTreeNode,
        selectedAttributeNode,
        selectAllMode,
        excludedItemsIds,
        tableSearch,
        tableFilter,
        hasLockedProducts,
        includeAttributeStatuses,
        reviewStatus,
    ]);
    return filterValue;
};
exports.useBulkActionsFilter = useBulkActionsFilter;
